module.exports = __webpack_public_path__ + "static/media/6.4e697fd9.jpg";